import { useNavigate } from 'react-router-dom';
import React from 'react';
import { SubscriptionOffer } from 'api/graphql';
import Style from './ZppOfferBox.style';
import { Headline, Image, Button, Paragraph } from 'View/Common';
import ZppSleepingLuna from 'img/ZppSleepingLuna';
import { linkHandler } from 'utils';

interface Props {
  offer: SubscriptionOffer;
}

export const ZppOfferBox: React.FC<Props> = ({ offer }) => {
  const navigate = useNavigate();
  const selectOffer = () => {
    navigate(`${linkHandler.get('zppLandingPage')}#erstattungscheck-box`);
  };

  return (
    <Style data-cy-name="offer-prevention-box">
      <div className="content-wrapper text-center">
        <Paragraph className="bold box-badge">Deine Krankenkasse zahlt!</Paragraph>
        <Image
          className="sleeping-luna-image"
          image={ZppSleepingLuna.src}
          srcSet={ZppSleepingLuna.srcSet}
          alt="Luna schlafend mit Erstattungscheck in der Hand"
        />
        <Headline level={3} className="offer-label">
          7Schläfer mit der <br />
          Krankenkasse
        </Headline>
        <Paragraph className="price-info-box">Werde zum 7Schläfer mit bis zu 100% Kostenerstattung durch deine Krankenkasse.</Paragraph>
        <br />
      </div>

      <Button
        onClick={selectOffer}
        className={`${offer.name.toLowerCase()}`}
        data-testid={`e2e_btn_buy_${offer.interval}`}
        data-cy-name="buy-prevention-button"
        title="Dieses Angebot jetzt kaufen"
      >
        Mehr erfahren
      </Button>
    </Style>
  );
};
